<template>
  <section class="content" style="padding:unset;">
    <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 serch-barr">

      <div class="row">
           <div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
             <p class="home-topic" style="padding-top: 11%;">Documents</p>
        </div>
        <div class="col-3 col-sm-3 col-md-4 col-lg-4 col-xl-4">

          <div class="searchBar" style="padding-top: 3%;">
            <input type="text" v-model="searchField" v-on:keyup.enter="getDocs"  class="searchTerm" placeholder="What are you looking for?">
            <button type="submit" class="searchButton">
              <i class="fa fa-search" @click="getDocs"></i>
            </button>
          </div>
        </div>
        <div class="col-3 col-sm-3 col-md-2 col-lg-2 col-xl-2">
          <md-field class="dddBox">
            <md-select class="dropDown"  name="orderBy" id="orderBy" v-model="selectOrderBySelected" placeholder="Sort Documents" @md-selected="getDocs('searching')">
              <md-option :value="cata.value" v-for="cata in selectOrderBy" v-bind:key="cata.value" >{{cata.desc}}
              </md-option>
            </md-select>
          </md-field>
        </div>
        <div class="col-3 col-sm-3 col-md-2 col-lg-2 col-xl-2">
          <md-field class="dddBox">
            <md-select class="dropDown" v-model="selectCata" placeholder="All Categories" @md-selected="getDocs('searching')">
              <md-option>
                All Categories
              </md-option>
              <md-option :value="cata.id" v-for="cata in allCata" v-bind:key="cata.id" >{{cata.name}}
              </md-option>
            </md-select>
          </md-field>
        </div>
        <div class="col-3 col-sm-3 col-md-2 col-lg-2 col-xl-2">
          <md-field class="dddBox">
            <md-select class="dropDown"  v-model="selectProduct" placeholder="All Products" @md-selected="getDocs('searching')">
              <md-option>
                All Products
              </md-option>
              <md-option :value="cata.id" v-for="cata in allProduct" v-bind:key="cata.id" >{{cata.name}}
              </md-option>
            </md-select>
          </md-field>
        </div>
        </div>
    </div>
    </div>

    <div class="row" v-if="!allDocs.hasOwnProperty('status')">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">

        <div class="row">
          <div class="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3" v-for="doc in allDocs" v-bind:key="doc.id">
            <div class="sg-str" @click="favoritDocument(doc.id, doc.favourite)">
              <i :id="doc.id" :class="[doc.favourite=='yes'?'fa fa-star':'fa fa-star-o']" aria-hidden="true">
              </i>
            </div>
            <router-link :to="'/documents/single-dcument/'+doc.category_id+'/'+doc.id">
              <div class="v-boxx">
<!--                <div class="sg-str"><i class="fa fa-star-o" aria-hidden="true"></i></div>-->
                <div class="v-videoo">
                   <img class="doc-img" v-bind:src='"https://smartapprcp.s3.ap-southeast-1.amazonaws.com/" + doc.thumbnail ' >
                </div>
                <div class="v-content">
                  <p class="v-name two-line-overflow">{{doc.name}}</p>
                  <!-- <ul class="v-name two-line-overflow2" style="padding-left:0;" >
                    <li class="badge bgg-pr"  v-for="product in doc.products" v-bind:key="product.id">
                      {{product.pro_name}}
                    </li>
                  </ul> -->
                  <p class="v-disc two-line-overflow">{{doc.description}}</p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="noContent==='yes'">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        No results found
      </div>
    </div>
    <div class="row" v-if="noContentErrorMsg">
      <!--        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">-->
      <vue-content-loading :width="300" :height="100">
        <rect x="0" y="13" rx="4" ry="4" width="23%" height="50"/>
        <rect x="0" y="66" rx="2" ry="2" width="23%" height="3"/>
        <rect x="0" y="72" rx="2" ry="2" width="14%" height="3"/>
        <rect x="0" y="78" rx="2" ry="2" width="23%" height="3"/>
        <rect x="0" y="84" rx="2" ry="2" width="23%" height="3"/>

        <rect x="25%" y="13" rx="4" ry="4" width="23%" height="50"/>
        <rect x="25%" y="66" rx="2" ry="2" width="23%" height="3"/>
        <rect x="25%" y="72" rx="2" ry="2" width="14%" height="3"/>
        <rect x="25%" y="78" rx="2" ry="2" width="23%" height="3"/>
        <rect x="25%" y="84" rx="2" ry="2" width="23%" height="3"/>

        <rect x="51%" y="13" rx="4" ry="4" width="23%" height="50"/>
        <rect x="51%" y="66" rx="2" ry="2" width="23%" height="3"/>
        <rect x="51%" y="72" rx="2" ry="2" width="14%" height="3"/>
        <rect x="51%" y="78" rx="2" ry="2" width="23%" height="3"/>
        <rect x="51%" y="84" rx="2" ry="2" width="23%" height="3"/>

        <rect x="77%" y="13" rx="4" ry="4" width="23%" height="50"/>
        <rect x="77%" y="66" rx="2" ry="2" width="23%" height="3"/>
        <rect x="77%" y="72" rx="2" ry="2" width="14%" height="3"/>
        <rect x="77%" y="78" rx="2" ry="2" width="23%" height="3"/>
        <rect x="77%" y="84" rx="2" ry="2" width="23%" height="3"/>
      </vue-content-loading>
      <!--        </div>-->
    </div>
    <div class="row">
      <div style="float: right;" v-if="allDocs.length!=0">
        <ul class="pagination">
          <li v-bind:class="{disable:pagination.current_page===pagination.from}" class="page-item">
            <a
              @click="pagination.current_page!==pagination.from && getUpdatePaginationDocs(pagination.first_page_url)"
              class="page-link"
            >&laquo;</a>
          </li>
          <li v-bind:class="{disable:!pagination.prev_page_url}" class="page-item">
            <a @click="pagination.current_page!==pagination.from && getUpdatePaginationDocs(pagination.prev_page_url)" class="page-link">&lt;</a>
          </li>
          <li
            v-for="n in pagination.last_page"
            v-bind:key="n"
            v-bind:class="{active:pagination.current_page == n}"
            class="page-item"
          >
            <a
              @click="pagination.current_page!==n && getUpdatePaginationDocs(pagination.path + '?page=' + n)"
              class="page-link"
            >{{n}}</a>
          </li>
          <li v-bind:class="{disable:!pagination.next_page_url}" class="page-item">
            <a @click="pagination.current_page!==pagination.last_page && getUpdatePaginationDocs(pagination.next_page_url)" class="page-link">&gt;</a>
          </li>
          <li v-bind:class="{disable:!pagination.last_page_url}" class="page-item">
            <a
              @click="pagination.current_page!==pagination.last_page && getUpdatePaginationDocs(pagination.last_page_url)"
              class="page-link"
            >&raquo;</a>
          </li>
        </ul>
      </div>
    </div>
    <back-to-top bottom="120px" right="20px" visibleoffset="20">
      <button type="button" class="scoller-top-btn"><i class="fa fa-chevron-up"></i></button>
    </back-to-top>
  </section>
</template>
<script>
  import dropdown from 'vue-dropdowns'
  import Alert from '../../widgets/Alert'
  import InfoBox from '../../widgets/InfoBox'
  import ProcessInfoBox from '../../widgets/ProcessInfoBox'
  import SmallBox from '../../widgets/SmallBox'
  import api from '../../../api'
  import VueContentLoading from 'vue-content-loading'
  import Vue from 'vue'
  import BackToTop from 'vue-backtotop'

  export default {
    name: 'homeView',
    components: {
      Alert,
      InfoBox,
      ProcessInfoBox,
      SmallBox,
      'dropdown': dropdown,
      VueContentLoading,
      BackToTop
    },
    data() {
      return {
        selectCata: '',
        selectProduct: '',
        allCata: [],
        allProduct: [],
        allDocs: [],
        searchField: '',
        noContent: 'no',
        noContentErrorMsg: true,
        pagination: {},
        favList: [],
        selectOrderBy: [
          {
            id: 1,
            value: 'numeric_asc',
            name: 'numeric',
            type: 'asc',
            desc: 'A to Z'
          },
          {
            id: 2,
            value: 'numeric_desc',
            name: 'numeric',
            type: 'desc',
            desc: 'Z to A'
          },
          {
            id: 3,
            value: 'date_asc',
            name: 'date',
            type: 'asc',
            desc: 'New to Old'
          },
          {
            id: 4,
            value: 'date_desc',
            name: 'date',
            type: 'desc',
            desc: 'Old to New'
          }
        ],
        selectOrderBySelected: ''
      }
    },
    computed: {
    },
    created() {
      this.getAllProduct()
      this.getAllCata()
      this.getDocs(this.$route.query.cat)
    },

    methods: {
      getAllCata() {
        api.request('get', '/admin/categories/select ')
          .then(response => {
            this.allCata = response.data.result
          })
      },
      getAllProduct() {
        api.request('get', '/customer/productList ')
          .then(response => {
            this.allProduct = response.data.products
          })
      },
      favoritDocument(id, type) {
        if (this.favList.length === 0) {
          this.favList.push(id + '-' + type)
          if (type === 'no') {
            document.getElementById(id).className = 'fa fa-star'
          } else {
            document.getElementById(id).className = 'fa fa-star-o'
          }
        } else {
          var b = true
          for (let x = 0; x < this.favList.length; x++) {
            var y = this.favList[x].split('-')
            if (y[0] === '' + id) {
              var tt = null
              if (y[1] === 'yes') {
                tt = 'no'
              } else {
                tt = 'yes'
              }
              if (tt === 'no') {
                document.getElementById(id).className = 'fa fa-star'
              } else {
                document.getElementById(id).className = 'fa fa-star-o'
              }
              b = false
              this.favList.splice(this.favList[x], 1)
            }
          }
          if (b) {
            this.favList.push(id + '-' + type)
            if (type === 'no') {
              document.getElementById(id).className = 'fa fa-star'
            } else {
              document.getElementById(id).className = 'fa fa-star-o'
            }
          }
        }
        this.favouriteBackendCall('documents', id)
      },
      favouriteBackendCall(mediaType, id) {
        api.request('get', '/customer/favourite/' + mediaType + '/' + id)
          .then(response => {
            //  this.getDocs()
          })
      },
      getDocs(initCatId) {
        var ref = this
        var catId = ref.selectCata
        var productId = ref.selectProduct
        var search = ref.searchField
        var deviceType = 'm'
        ref.noContent = 'no'
        ref.allDocs = []
        var paramSelectOrderBySelected = ''

        ref.noContentErrorMsg = true
        if (initCatId && initCatId > 0 && initCatId !== 'searching') {
          ref.selectCata = initCatId
          catId = initCatId
        }
        if (ref.selectCata === null || ref.selectCata === '' || !ref.selectCata) {
          catId = 'all'
          ref.selectCata = 'all'
        }
        if (ref.selectProduct === null || ref.selectProduct === '' || !ref.selectProduct) {
          productId = 'all'
          ref.selectProduct = 'all'
        }
        if (ref.searchField === null || ref.searchField === '' || !ref.searchField) {
          search = 'all'
        }

        if (ref.selectOrderBySelected !== undefined || ref.selectOrderBySelected !== '' || ref.selectOrderBySelected) {
          paramSelectOrderBySelected = ref.selectOrderBySelected
        }
        api.request('get', '/customer/search/documents/' + catId + '/' + productId + '/' + deviceType + '?search_key=' + search + '&orderby=' + paramSelectOrderBySelected)
          .then(response => {
            if (response.data.result.hasOwnProperty('status') && response.data.result.status === 'error') {
              ref.noContent = 'yes'
            }
            ref.allDocs = response.data.result
            ref.pagination = response.data.pagination
            ref.noContentErrorMsg = false
          })
      },
      getUpdatePaginationDocs(pegination) {
        var ref = this
        var url = pegination
        api.httpRequestCore({method: 'get', url: url, headers: { Authorization: 'Bearer ' + Vue.auth.getToken() }})
          .then(response => {
            if (response.data.result.hasOwnProperty('status') && response.data.result.status === 'error') {
              ref.noContent = 'yes'
            }
            ref.allDocs = response.data.result
            ref.pagination = response.data.pagination
            this.noContentErrorMsg = false
          })
      }
    }

  }
</script>
<style>
  @media (min-width: 320px) and (max-width: 480px) {
    .video-list-thumbs .glyphicon-play-circle {
      font-size: 35px;
      right: 36%;
      top: 27%;
    }

    .video-list-thumbs h2 {
      bottom: 0;
      font-size: 12px;
      height: 22px;
      margin: 8px 0 0;
    }
  }
  .top-right {
    position: absolute;
    top: 8px;
    right: 16px;
  }
</style>



// WEBPACK FOOTER //
// UserDouments.vue?2024da62